module.exports = __webpack_public_path__ + "img/313-4ce3b3.png";